'use strict';

(() => {
  window.mx = window.mx || {};

  window.mx.components.MxFooter = class extends window.mx.components.MxComponent {
    constructor() {
      super();
    }

    connectedCallback() {
      this.events.add(this.chatLink, 'click', () => {
        window.mx.utils.gorgias.open();
      });

      this.events.add(this.cookieLink, 'click', () => {
        // Open cookie settings modal
      });
    }

    get chatLink() {
      return this.cache.get('dom', 'chatLink', () => this.querySelector('.chat-link'));
    }
    get cookieLink() {
      return this.cache.get('dom', 'cookiesLink', () => this.querySelector('.cookies-link'));
    }
  };
  if (!customElements.get('mx-footer')) {
    customElements.define('mx-footer', window.mx.components.MxFooter);
  }
})();
